import { State, StateStatus } from './models'
import { MediaItemData } from '../../models/mediaItemData'
import { RootState } from '../rootState'

export const selectMoviesState = (state: RootState): State => state.movies
export const selectMovies = (state: RootState): MediaItemData[] => Object.values(selectMoviesState(state).items)
export const selectMovie = (id: number) =>
  (state: RootState): MediaItemData => selectMoviesState(state).items[id]
export const selectMoviesStateStatus = (state: RootState): StateStatus => selectMoviesState(state).status
